import React, { useContext, useEffect } from "react";
import { DisplayDiscussionForMiniScreenContext } from "../contexts/DisplayDiscussionForMiniScreenContext";
import Chatbot from "../components/chat/Chatbot";
// import { AuthContext } from "../contexts/AuthContext";
// import { socket } from "../services/socket";

export default function ContentSquelette({ children }) {
  // const { user } = useContext(AuthContext);
  const {
    destinataire,
    crew,
    setDestinataire,
    setDisplayDiscussionForMiniScreen,
    displayDiscussionForMiniScreen,
  } = useContext(DisplayDiscussionForMiniScreenContext);
  useEffect(() => {
    setDestinataire(destinataire);
    setDisplayDiscussionForMiniScreen(displayDiscussionForMiniScreen);
  }, [destinataire]);
  return (
    <>
      <div className="tyn-content tyn-content-full-height tyn-chat has-aside-base">
        {children}
      </div>
      {!destinataire && !crew && <Chatbot />}
    </>
  );
}
